var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 102,
    viewBox: "0 0 97 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.1886 101.114H0V16.6219H18.3473V84.739H80.1886V101.105V101.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.1885 32.9879C89.2272 32.9879 96.5544 25.6606 96.5544 16.622C96.5544 7.58337 89.2272 0.256104 80.1885 0.256104C71.1499 0.256104 63.8226 7.58337 63.8226 16.622C63.8226 25.6606 71.1499 32.9879 80.1885 32.9879Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.5545,
    height: 100.858,
    fill: "white",
    transform: "translate(0 0.256104)"
  })))));
};
export default SvgLogoNoText;